//引入刚才的http.js文件
import https from './http.js';
import qs from 'qs';
//设置个对象，就不用一个个暴露了，直接暴露对象
let apiFun = {};


//get请求列表
//登录前获取图形码
apiFun.captcha = function (params) {
	return https.get("/passport/none/captcha" +
		"?t=" + new Date().valueOf())
}
apiFun.positionTypeSearch = function (params) {
	return https.get('/passport/none/positionTypeSearch', params)
}


//post请求列表
//登录前获取key
apiFun.getLoginRsaKey = function (params) {
	return https.post('/passport/none/getLoginRsaKey', params)
}
//登录前获取key(新)
apiFun._getLoginRsaKey = function (params) {
	return https._get('/v3/passport/getLoginRsaKey', params)
}
apiFun.skillAll = function (params) {
	return https.post('/recruit/skill/skillAll', params)
}


//formDataPost请求列表
//账号密码接口
apiFun.login = function (params) {
	return https.formDataPost('/passport/none/login', params)
}
//账号密码接口
apiFun._login = function (params) {
	return https.post('/v3/passport/login', params)
}
//登录获取短信验证码
apiFun.sendSms = function (params) {
	return https.formDataPost('/passport/none/sendSms', params)
}
//登录获取短信验证码
apiFun._sendSms = function (params) {
	return https.post('/v3/passport/sendSms', params)
}
//短信验证码登录接口
apiFun.loginBySms = function (params) {
	return https.formDataPost('/passport/none/loginBySms', params)
}
//短信验证码登录接口
apiFun._loginBySms = function (params) {
	return https.post('/v3/passport/loginBySms', params)
}
apiFun.officialSubmit = function (params) {
	return https.formDataPost('/passport/none/officialSubmit', params)
}

apiFun.getNewsListByTime = function (params) {
	return https.formDataPost('/passport/none/getNewsListByTime', params)
}

apiFun.CompanyManagementCenter = function (params) {
	return https.formDataPost('/recruit/company/CompanyManagementCenter', params)
}

apiFun.companyPositionShow = function (params) {
	return https.formDataPost('/recruit/company/position/companyPositionShow', params)
}

apiFun.recordMsg = function (params) {
	return https.formDataPost('/recruit/recordMsg/get', params)
}

apiFun.candidateManagement = function (params) {
	return https.formDataPost('/recruit/resume/record/candidateManagement', params)
}

apiFun.seekPersonnel = function (params) {
	return https.formDataPost('/recruit/company/position/seekPersonnel', params)
}


apiFun.getUserDetail = function (params) {
	return https.formDataPost('/recruit/resume/getUserDetail', qs.stringify(params))
}

apiFun.SeePersonnelDetail = function (params) {
	return https.formDataPost('/recruit/resume/SeePersonnelDetail', qs.stringify(params))
}


apiFun.candidateHandle = function (params) {
	return https.formDataPost('/recruit/resume/candidateHandle', qs.stringify(params))
}

apiFun.update = function (params) {
	return https.formDataPost('/recruit/recordMsg/update', qs.stringify(params))
}

apiFun.sendResumeEail = function (params) {
	return https.formDataPost('/recruit/mail/sendResumeEail', qs.stringify(params))
}

apiFun.positionDetails = function (params) {
	return https.formDataPost('/recruit/company/position/positionDetails', qs.stringify(params))
}

apiFun.AICompanyPosition = function (params) {
	return https.formDataPost('/recruit/company/position/AICompanyPosition', qs.stringify(params))
}

apiFun.joinTheCandidate = function (params) {
	return https.formDataPost('/recruit/resume/joinTheCandidate', qs.stringify(params))
}

apiFun.dictionary = function (params) {
	return https.formDataPost('/college/none/system/dictionary/load', qs.stringify(params))
}

apiFun.pTypeList = function (params) {
	return https.formDataPost('/recruit/positionType/pTypeList', qs.stringify(params))
}

apiFun.positionsave = function (params) {
	return https.formDataPost('/recruit/company/position/save', qs.stringify(params))
}

apiFun.getPositionDetail = function (params) {
	return https.formDataPost('/recruit/company/position/get', qs.stringify(params))
}

apiFun.getUnitInfo = function (params) {
	return https.formDataPost('/recruit/company/get', qs.stringify(params))
}

apiFun.getCityData = function (params) {
	return https.formDataPost('/activity/none/sys/region/getList', qs.stringify(params))
}

//暴露出这个对象
export default apiFun;

